import styled from "styled-components";

export const Container = styled.div`
  width: 70%;
  padding: 20px 10px;
  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #3730a3;
        background-color: #3730a3;
      }
    }
  }

  @media screen and (max-width: 820px) {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  @media screen and (max-width: 820px) {
    grid-template-columns: repeat(1, 1fr);
    border: none;
    padding: 5px;
    gap: 5px;
  }

  padding: 25px 10px;
  border-bottom: 1px solid #e0e2e6;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  label {
    margin-top: 20px;
    color: #344054;
    font-size: 14px;
  }
  p {
    margin-top: 5px;
    font-size: 14px;
    color: #667085;
  }
  .date {
    display: flex;
    gap: 10px;
  }

  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    //height: 43px;
    margin-top: 10px;
    border: solid 1px #e0e2e6;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: #4f46e5;
      border: 1px solid #3730a3;
      background: transparent;
    }
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  input[type="range"] {
    margin-right: 10px;
    background-color: #4f46e5;
  }
  span {
    white-space: nowrap;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  //gap: 5px;
`;

export const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  //gap: 5px;
`;
export const ProofOfPaymentContainer = styled.div`
  border: 1px solid #d0d5dd;
  padding: 20px;
  text-align: center;
  border-radius: 5px;
`;
export const FileInputLabel = styled.label`
  display: block;
  cursor: pointer;
  .text {
    margin-top: -15px;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  border-radius: 5px;
`;
// export const Tooltip = styled.div`
//   position: absolute;
//   top: 64%;
//   left: calc(50% + 10px); /* Adjust position */
//   transform: translateY(-50%);
//   background: #fff;
//   border: 1px solid #ccc;
//   border-radius: 8px;
//   padding: 8px 12px;
//   font-size: 14px;
//   color: #333;
//   box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
//   white-space: nowrap;
//   z-index: 10;

//   &::before {
//     content: "";
//     position: absolute;
//     top: 50%;
//     right: 100%;
//     transform: translateY(-50%);
//     border: 6px solid transparent;
//     border-right-color: #ccc;
//   }

//   strong {
//     display: block;
//     font-weight: bold;
//     margin-bottom: 4px;
//   }

//   p {
//     margin: 0;
//     font-size: 12px;
//     color: #666;
//   }
// `;

export const InputWrapper = styled.div`
  position: relative;

  input {
    width: 100%;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -80px;
  left: 0%;
  background: #f8f9fa;
  border: 1px solid #e0e2e6;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 14px;
  color: #344054;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  z-index: 10;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border: 6px solid transparent;
    border-right-color: #e0e2e6;
  }

  strong {
    display: block;
    font-weight: bold;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    font-size: 12px;
    color: #667085;
  }
`;